import { render } from "./BaseTooltip.vue?vue&type=template&id=d813d1c0&scoped=true"
import script from "./BaseTooltip.vue?vue&type=script&lang=js"
export * from "./BaseTooltip.vue?vue&type=script&lang=js"

import "./BaseTooltip.vue?vue&type=style&index=0&id=d813d1c0&lang=scss&scoped=true"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d813d1c0"]])

export default __exports__